import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import "./mainStyles.css";
// Fonts
import './assets/fonts/style.css';


import Home from "./components/Home";
import Projects from "./components/Projects";
import Pokemon from "./components/Pokemon/Main";
import Teamsheet from "./components/Pokemon/Teamsheet";
import PokemonAsiaCup2021 from "./components/Pokemon/AsiaCup2021";
import GaOleGuidePP from "./components/GaOleGuide/PP";
import MezastarGuidePP from "./components/MezastarGuide/PP";
import Senior from "./components/Senior";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const styles = {
  root: {
    flexGrow: 1,
  },
};

class App extends Component {
  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  render() {
    return (
      <div
        className="App"
        style={{
          overflow: "hidden",
        }}
      >
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Open+Sans"
        />
        <link href="https://fonts.googleapis.com/css?family=Montserrat" rel="stylesheet" />
        <BrowserRouter
          basename={"tehdrink"}
        >
          <Navbar />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/home" component={Home} />
            <Route exact path="/projects" component={Projects} />
            <Route exact path="/pokemon" component={Pokemon} />
            <Route exact path="/teamsheet" component={Teamsheet} />
            <Route exact path="/pokemon-asia-cup-2021" component={PokemonAsiaCup2021} />
            <Route exact path="/gaoleguide-privacy-policy" component={GaOleGuidePP} />
            <Route exact path="/mezastarguide-privacy-policy" component={MezastarGuidePP} />
            {/* <Route exact path="/pokemon-ga-ole-authenticity-guide" component={GaOleAuthenticityGuide} /> */}
            <Route exact path="/elementary" component={Navbar} />
            <Route exact path="/junior" component={Navbar} />
            <Route exact path="/senior" component={Senior} />
            <Route path="/" component={Home} />
          </Switch>
          <Footer />
          <ins className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-format="fluid"
            data-ad-layout-key="-fb+5w+4e-db+86"
            data-ad-client="ca-pub-3861773134479345"
            data-ad-slot="1144694859"
          ></ins>
        </BrowserRouter>
      </div>
    );
  }
}

export default withStyles(styles)(App);
